import * as React from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import Alert from "components/collectFunnel/steps/collectFunnelConfirmationStep/assets/alert.svg";

export const CollectProductRecap = ({ deliveryItems }) => {
  const classes = useStyles();

  return (
    <>
      <Box mt={4} mb={2} className={classes.alertMessage}>
        <Alert />
        <Typography variant="body2" className={classes.alertText}>
          {deliveryItems.length > 1 ? `Codes à indiquer sur les appareils` : `Code à indiquer sur l’appareil`}
        </Typography>
      </Box>
      {deliveryItems.map((deliveryItem, index) => (
        <Box key={deliveryItem.collection_code} className={classes.productBox}>
          {
            <Typography variant="body2">
              Appareil {index + 1} • {deliveryItem.product_type} • {deliveryItem.product_brand}
            </Typography>
          }
          {deliveryItem.collection_code && (
            <Typography variant="h1" className={classes.reference}>
              {deliveryItem.collection_code}
            </Typography>
          )}
        </Box>
      ))}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  productBox: {
    background: theme.palette.text.turquoise,
    color: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  reference: {
    fontWeight: "normal",
    marginTop: theme.spacing(1),
  },
  alertMessage: {
    color: "#ff757b",
    alignItems: "center",
    display: "flex",
  },
  alertText: {
    marginLeft: theme.spacing(1),
  },
}));
